import {} from '@bendingspoons/pico-core';
/**
 * An helper to generate an unique id stored in the local storage.
 * Such ID stays the same until when the local storage is not erased.
 *
 * @param keySuffix A suffix used to generate an unique key to store the id. The name of the product may be a good choice
 * @param uuidGenerator A function that generates an unique uuid4 string
 * @returns An `IdGenerator` that can be passed to pico
 */
export const localStorageID = (keySuffix, uuidGenerator) => {
    if (typeof window === 'undefined') {
        throw new Error('This helper can only be used in web-based environments');
    }
    const itemKeyName = `LOCAL_STORAGE_ID_${keySuffix}`;
    return async () => {
        const localStorageId = window.localStorage.getItem(itemKeyName);
        if (localStorageId == null) {
            const newLocalStorageId = uuidGenerator();
            window.localStorage.setItem(itemKeyName, newLocalStorageId);
            return newLocalStorageId;
        }
        return localStorageId;
    };
};
//# sourceMappingURL=localStorageID.js.map